module.exports = __webpack_public_path__ + "images/application/i-new-tab-0b24fb54.svg";